export default {
  tooltipTopOffset: 3,
  tooltipVisibleDelayTimeMillis: 300, // same milliseconds as TooltipDelay.medium in fluent ui library
};
